// labelsVersion — a monotonic counter bumped whenever the sensor-mapping cache
// changes (issue #4). View-models that produce labeled output thread this into
// their useMemo dependency arrays so a rename live-updates rendered charts,
// tables, and tooltips without a reload.
//
// The resolver cache itself (labelResolver.ts) is a plain module so pure
// functions can read it; this store is the React-visible signal that the cache
// moved. Read useLabelsVersion() in a component/hook to subscribe.

import { create } from 'zustand';

interface LabelsVersionStore {
  version: number;
  bump: () => void;
}

export const useLabelsVersionStore = create<LabelsVersionStore>((set) => ({
  version: 0,
  bump: () => set((s) => ({ version: s.version + 1 })),
}));

/** Subscribe to the labels version (re-renders on every rename). */
export const useLabelsVersion = () => useLabelsVersionStore((s) => s.version);

/** Bump from non-React code (e.g. a react-query onSuccess). */
export const bumpLabelsVersion = () => useLabelsVersionStore.getState().bump();
